/* tslint:disable */
/* eslint-disable */
/**
 * CipherMail portal back-end API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { PdfReplyParameters } from '../model';
/**
 * PDFApi - axios parameter creator
 * @export
 */
export const PDFApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} passwordID 
         * @param {number} passwordLength 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pDFControllerGetOTPJSONCode: async (passwordID: string, passwordLength: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'passwordID' is not null or undefined
            assertParamExists('pDFControllerGetOTPJSONCode', 'passwordID', passwordID)
            // verify required parameter 'passwordLength' is not null or undefined
            assertParamExists('pDFControllerGetOTPJSONCode', 'passwordLength', passwordLength)
            const localVarPath = `/api/pdf/getOTPJSONCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (passwordID !== undefined) {
                localVarQueryParameter['passwordID'] = passwordID;
            }

            if (passwordLength !== undefined) {
                localVarQueryParameter['passwordLength'] = passwordLength;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} passwordID 
         * @param {number} passwordLength 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pDFControllerGetOTPQRCode: async (passwordID: string, passwordLength: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'passwordID' is not null or undefined
            assertParamExists('pDFControllerGetOTPQRCode', 'passwordID', passwordID)
            // verify required parameter 'passwordLength' is not null or undefined
            assertParamExists('pDFControllerGetOTPQRCode', 'passwordLength', passwordLength)
            const localVarPath = `/api/pdf/getOTPQRCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (passwordID !== undefined) {
                localVarQueryParameter['passwordID'] = passwordID;
            }

            if (passwordLength !== undefined) {
                localVarQueryParameter['passwordLength'] = passwordLength;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pDFControllerGetOTPSecretKey: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/pdf/getOTPSecretKey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pDFControllerGetOTPSecretKeyQRCode: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/pdf/getOTPSecretKeyQRCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pDFControllerGetPdfPassword: async (code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('pDFControllerGetPdfPassword', 'code', code)
            const localVarPath = `/api/pdf/getPdfPassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} env 
         * @param {string} hmac 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pDFControllerParsePdfReplyParameters: async (env: string, hmac: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'env' is not null or undefined
            assertParamExists('pDFControllerParsePdfReplyParameters', 'env', env)
            // verify required parameter 'hmac' is not null or undefined
            assertParamExists('pDFControllerParsePdfReplyParameters', 'hmac', hmac)
            const localVarPath = `/api/pdf/parsePdfReplyParameters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (env !== undefined) {
                localVarQueryParameter['env'] = env;
            }

            if (hmac !== undefined) {
                localVarQueryParameter['hmac'] = hmac;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} env 
         * @param {string} hmac 
         * @param {string} textBody 
         * @param {Array<File>} [attachments] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pDFControllerSendPdfReply: async (env: string, hmac: string, textBody: string, attachments?: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'env' is not null or undefined
            assertParamExists('pDFControllerSendPdfReply', 'env', env)
            // verify required parameter 'hmac' is not null or undefined
            assertParamExists('pDFControllerSendPdfReply', 'hmac', hmac)
            // verify required parameter 'textBody' is not null or undefined
            assertParamExists('pDFControllerSendPdfReply', 'textBody', textBody)
            const localVarPath = `/api/pdf/sendPdfReply`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (env !== undefined) { 
                localVarFormParams.append('env', env as any);
            }
    
            if (hmac !== undefined) { 
                localVarFormParams.append('hmac', hmac as any);
            }
    
            if (textBody !== undefined) { 
                localVarFormParams.append('textBody', textBody as any);
            }
                if (attachments) {
                attachments.forEach((element) => {
                  localVarFormParams.append('attachments', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PDFApi - functional programming interface
 * @export
 */
export const PDFApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PDFApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} passwordID 
         * @param {number} passwordLength 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pDFControllerGetOTPJSONCode(passwordID: string, passwordLength: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pDFControllerGetOTPJSONCode(passwordID, passwordLength, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PDFApi.pDFControllerGetOTPJSONCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} passwordID 
         * @param {number} passwordLength 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pDFControllerGetOTPQRCode(passwordID: string, passwordLength: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pDFControllerGetOTPQRCode(passwordID, passwordLength, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PDFApi.pDFControllerGetOTPQRCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pDFControllerGetOTPSecretKey(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pDFControllerGetOTPSecretKey(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PDFApi.pDFControllerGetOTPSecretKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pDFControllerGetOTPSecretKeyQRCode(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pDFControllerGetOTPSecretKeyQRCode(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PDFApi.pDFControllerGetOTPSecretKeyQRCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pDFControllerGetPdfPassword(code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pDFControllerGetPdfPassword(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PDFApi.pDFControllerGetPdfPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} env 
         * @param {string} hmac 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pDFControllerParsePdfReplyParameters(env: string, hmac: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PdfReplyParameters>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pDFControllerParsePdfReplyParameters(env, hmac, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PDFApi.pDFControllerParsePdfReplyParameters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} env 
         * @param {string} hmac 
         * @param {string} textBody 
         * @param {Array<File>} [attachments] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pDFControllerSendPdfReply(env: string, hmac: string, textBody: string, attachments?: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pDFControllerSendPdfReply(env, hmac, textBody, attachments, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PDFApi.pDFControllerSendPdfReply']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PDFApi - factory interface
 * @export
 */
export const PDFApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PDFApiFp(configuration)
    return {
        /**
         * 
         * @param {string} passwordID 
         * @param {number} passwordLength 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pDFControllerGetOTPJSONCode(passwordID: string, passwordLength: number, options?: any): AxiosPromise<string> {
            return localVarFp.pDFControllerGetOTPJSONCode(passwordID, passwordLength, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} passwordID 
         * @param {number} passwordLength 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pDFControllerGetOTPQRCode(passwordID: string, passwordLength: number, options?: any): AxiosPromise<string> {
            return localVarFp.pDFControllerGetOTPQRCode(passwordID, passwordLength, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pDFControllerGetOTPSecretKey(options?: any): AxiosPromise<string> {
            return localVarFp.pDFControllerGetOTPSecretKey(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pDFControllerGetOTPSecretKeyQRCode(options?: any): AxiosPromise<string> {
            return localVarFp.pDFControllerGetOTPSecretKeyQRCode(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pDFControllerGetPdfPassword(code: string, options?: any): AxiosPromise<string> {
            return localVarFp.pDFControllerGetPdfPassword(code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} env 
         * @param {string} hmac 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pDFControllerParsePdfReplyParameters(env: string, hmac: string, options?: any): AxiosPromise<PdfReplyParameters> {
            return localVarFp.pDFControllerParsePdfReplyParameters(env, hmac, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} env 
         * @param {string} hmac 
         * @param {string} textBody 
         * @param {Array<File>} [attachments] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pDFControllerSendPdfReply(env: string, hmac: string, textBody: string, attachments?: Array<File>, options?: any): AxiosPromise<void> {
            return localVarFp.pDFControllerSendPdfReply(env, hmac, textBody, attachments, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PDFApi - object-oriented interface
 * @export
 * @class PDFApi
 * @extends {BaseAPI}
 */
export class PDFApi extends BaseAPI {
    /**
     * 
     * @param {string} passwordID 
     * @param {number} passwordLength 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PDFApi
     */
    public pDFControllerGetOTPJSONCode(passwordID: string, passwordLength: number, options?: RawAxiosRequestConfig) {
        return PDFApiFp(this.configuration).pDFControllerGetOTPJSONCode(passwordID, passwordLength, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} passwordID 
     * @param {number} passwordLength 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PDFApi
     */
    public pDFControllerGetOTPQRCode(passwordID: string, passwordLength: number, options?: RawAxiosRequestConfig) {
        return PDFApiFp(this.configuration).pDFControllerGetOTPQRCode(passwordID, passwordLength, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PDFApi
     */
    public pDFControllerGetOTPSecretKey(options?: RawAxiosRequestConfig) {
        return PDFApiFp(this.configuration).pDFControllerGetOTPSecretKey(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PDFApi
     */
    public pDFControllerGetOTPSecretKeyQRCode(options?: RawAxiosRequestConfig) {
        return PDFApiFp(this.configuration).pDFControllerGetOTPSecretKeyQRCode(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PDFApi
     */
    public pDFControllerGetPdfPassword(code: string, options?: RawAxiosRequestConfig) {
        return PDFApiFp(this.configuration).pDFControllerGetPdfPassword(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} env 
     * @param {string} hmac 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PDFApi
     */
    public pDFControllerParsePdfReplyParameters(env: string, hmac: string, options?: RawAxiosRequestConfig) {
        return PDFApiFp(this.configuration).pDFControllerParsePdfReplyParameters(env, hmac, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} env 
     * @param {string} hmac 
     * @param {string} textBody 
     * @param {Array<File>} [attachments] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PDFApi
     */
    public pDFControllerSendPdfReply(env: string, hmac: string, textBody: string, attachments?: Array<File>, options?: RawAxiosRequestConfig) {
        return PDFApiFp(this.configuration).pDFControllerSendPdfReply(env, hmac, textBody, attachments, options).then((request) => request(this.axios, this.basePath));
    }
}

